import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import Table from "../../common/Table";

import { HalfYearContext } from "../../../contexts/halfYearContext";

const Discounts = () => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles] = useState({ mainTitle: "تخفیف ها" });

  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    { path: "name", label: "نام (فارسی)" },
    { path: "name_en", label: "نام انگلیسی" },
    { path: "total", label: "مجموعه" },
  ];

  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    requestData();

    return () => {
      setRows([]);
      setSummary(null);
    };
  }, []);

  const requestData = async () => {
    try {
      let query = `students/discounts/types?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
        setRows(list);
        setSummary(data?.summary ?? null);
      });
    } catch ({ response }) {
      setRows([]);
      setSummary(null);
    }
  };

  return (
    <main className="main-print-wrapper discounts-print">
      <PrintHeader
        title={tableTitles.mainTitle}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <div className="print-table-area">
        <Table columns={columns} data={rows} />
      </div>
      {summary ? (
        <div className="discounts-print-total" aria-label="مجموعه کل">
          <span>مجموعه</span>
          <strong>{summary.total ?? summary.amount ?? ""}</strong>
        </div>
      ) : null}
    </main>
  );
};

export default Discounts;
